import { TextProps } from '../TextMaskPanels.types';
import React, { useImperativeHandle } from 'react';
import styles from '../TextMaskPanels.scss';

export const SvgMeasure = React.forwardRef((props, ref) => {
  const svgRef = React.useRef<SVGSVGElement>(null);

  useImperativeHandle(
    ref,
    (): {
      getViewbox: (props: TextProps) => string;
    } => ({
      getViewbox: (textProps) => {
        const svgElement = svgRef.current;
        if (svgElement) {
          svgElement.innerHTML = createTextElements(textProps);
          const { width, height } = svgElement.getBBox?.() ?? {};
          return !(width && height) ? '0 0 0 0' : `0 0 ${width} ${height}`;
        }
        return '0 0 0 0';
      },
    }),
  );

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      className={styles.measureSvg}
      ref={svgRef}
    ></svg>
  );
});

const createTextElements = (props: TextProps) => {
  const {
    text,
    align,
    direction,
    lineHeight,
    letterSpacing,
    size,
    family,
    weight,
    style,
    decoration,
    transform,
  } = props;

  let x: string;
  switch (align) {
    case 'start':
    default:
      x = direction === 'rtl' ? '100%' : '0';
      break;

    case 'middle':
      x = '50%';
      break;

    case 'end':
      x = direction === 'rtl' ? '0' : '100%';
      break;
  }
  return text
    .split('\n')
    .map(
      (line, index) =>
        `<text
          key="text-line-${index}"
          x="${x}"
          y="${index * lineHeight!}em"
          style="
            letter-spacing: ${letterSpacing?.value}${letterSpacing?.type};
            direction: ${direction};
            fill: #000;
            font-size: ${size}px;
            font-family: ${family};
            font-weight: ${weight};
            font-style: ${style};
            text-anchor: ${align};
            text-decoration: ${decoration};
            text-transform: ${transform};"
        >
          ${line.trim()}
        </text>`,
    )
    .join('');
};
